import jwt_decode from "jwt-decode";
import {HelpHttp} from "helpers/HelpHttp";
import {trackPromise} from "react-promise-tracker";

export const HelpFunctions = () => {
    
    const updateParam = async (data) => {
        let api = HelpHttp();
        //console.log('data', data);
        const url = `${process.env.REACT_APP_API}/parameters/updateByServiceAndParameter/${data.service}/${data.parameter}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};

        return trackPromise(api.put(url, options).then(res => res));
    }

    const updateResponseByDefault = async (data, id) => {
        let api = HelpHttp();
        const url = `${process.env.REACT_APP_API}/services/responseByDefault/${id}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};

        return trackPromise(api.put(url, options).then(res => res));
    }

    const logout = () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    };

    const decodeToken = (token) => {
        try {
            return jwt_decode(token);
        } catch (error) {
            logout();
        }
    };

    const alias = () => {
        let name = '';
        let token = localStorage.getItem('token') || null;
        if (token) {

            const decoded = decodeToken(token);
            if (decoded.name) {
                name = decoded.name;
            }
        }
        return name;
    };

    const rol = () => {
        let rol = '';
        let token = localStorage.getItem('token') || null;
        if (token) {

            const decoded = decodeToken(token);
            if (decoded.rol) {
                rol = decoded.rol;
            }
        }
        return rol;
    };

    const titleToAbilities = (word) => {
        console.log(word);
        const words = [
            {en: 'user', es: 'Gestión  de Usuarios'},
            {en: 'service', es: 'Gestión de Servicios'},
            {en: 'ability', es: 'Gestión de Autorizaciones'},
            {en: 'parameter', es: 'Gestión de Parámetros'},
            {en: 'product', es: 'Gestión de Productos'},
            {en: 'line', es: 'Gestión de Lineas'},
            {en: 'customer', es: 'Gestión de Clientes'},
            {en: 'departament', es: 'Gestión de Departamentos'},
            {en: 'center', es: 'Gestión de Centros'},
            {en: 'processlog', es: 'Gestión de Logs'},
            {en: 'flujo', es: 'Gestión de Flujos'},
            {en: 'proyecto', es: 'Gestión de Proyectos'},
            {en: 'error', es: 'Gestión de Errors'},
            {en: 'servicioshogarplanes', es: 'Gestión de Servicios Hogar Planes'},
            {en: "flujosStructure", es: "Gestión de Flujos Estructure"},
            {en: "nivelesStructure", es: "Gestión de Niveles Estructure"},
            {en: "flujosAddressComplement", es: "Gestión de Flujos Address Complement"},
            {en: "direction", es: "Gestión de Direcciones"},
            {en: "email", es: "Gestión de Correos"},
            {en: 'organization', es: 'Gestión de Organizaciones'},



        ];
        const found = words.find(x => x.en === word);
        return found ? found.es : word;
    }

    const capitalizeFirstLetter = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    return {updateResponseByDefault, updateParam, logout, alias, rol, decodeToken, titleToAbilities, capitalizeFirstLetter};
}
